import RepartitionData from "@/domain/entities/dashboard/RepartitionData";
import SmartLabel from "@/domain/enums/SmartLabel";
import { useTranslation } from "react-i18next";
import SmartLabelWithName from "./SmartLabelWithName";

type TooltipContentProps = {
    data: RepartitionData;
};

const TooltipContent = ({ data }: TooltipContentProps) => {
    const { t } = useTranslation();

    const messageKey =
        data.id === SmartLabel.Focus
            ? "dashboard.widgets.repartition.unprocessed-messages"
            : "dashboard.widgets.repartition.emails";

    return (
        <div className="flex items-center gap-2 text-sm">
            <SmartLabelWithName smartLabel={data.id} />
            <p>{t(messageKey, { count: data.value })}</p>
        </div>
    );
};

export default TooltipContent;
